class ActionProvider {
    constructor(createChatBotMessage, setStateFunc) {
      this.createChatBotMessage = createChatBotMessage;
      this.setState = setStateFunc;
    }
  
    handleGoluzdravac = () => {
      const message = this.createChatBotMessage(
        "Treba uraditi to, to i to za goluždravca."
      );
  
      this.addMessageToState(message);
    };

    handleCucavac = () => {
      const message = this.createChatBotMessage(
        "Treba uraditi to, to i to za čučavca."
      );
  
      this.addMessageToState(message);
    };

    handlePoletarac = () => {
      const message = this.createChatBotMessage(
        "Treba uraditi to, to i to za poletarca."
      );
  
      this.addMessageToState(message);
    };

    handleCiopa = () => {
      const message = this.createChatBotMessage(
        "Treba uraditi to, to i to za čiopu."
      );
  
      this.addMessageToState(message);
    };
  
    handleInjuredYes = () => {
      const message =  this.createChatBotMessage(`Kako ptić izgleda?`, {
        widget: "optionsStage",
      });
  
      this.addMessageToState(message);
    };
  
    handleInjuredNo = () => {
      const message =  this.createChatBotMessage(`Potrebno je da se obratite lokalnom zavodu ili udruženju za zaštitu ptica, Zavodu za zaštitu prirode ili prihvatilištu za za divlje životinje za savet. Odakle ste?`, {
        widget: "optionsLocations",
      });
  
      this.addMessageToState(message);
    };

    handleVojvodina = () => {
      const message =  this.createChatBotMessage(`Pozovite entitet XXX na broj telefona: xxx`);
      this.addMessageToState(message);
    }
    
    handleZapadnaSrbija = () => {
      const message =  this.createChatBotMessage(`Pozovite entitet XXX na broj telefona: xxx`);
      this.addMessageToState(message);
    }
    
    handleCentralnaSrbija = () => {
      const message =  this.createChatBotMessage(`Pozovite entitet XXX na broj telefona: xxx`);
      this.addMessageToState(message);
    }

    handleJuznaIstocnaSrbija = () => {
      const message =  this.createChatBotMessage(`Pozovite entitet XXX na broj telefona: xxx`);
      this.addMessageToState(message);
    }

    addMessageToState = (message) => {
      this.setState((prevState) => ({
        ...prevState,
        messages: [...prevState.messages, message],
      }));
    };
  }
  
  export default ActionProvider;
  